import { render, staticRenderFns } from "./MyAddonsDetails.vue?vue&type=template&id=1440fde2"
import script from "./MyAddonsDetails.vue?vue&type=script&lang=js"
export * from "./MyAddonsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports